import styled from "@emotion/styled";

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;
